export const externalAccess = {
  "externalAccess.title": "יישומים מחוברים",
  "externalAccess.subtitle": "גישה של היישומים שלך לקריאה ולחיפוש בעזרה הזמינה לך בארגון.",
  'externalAccess.failed': 'לא ניתן לטעון או לשנות את החיבור. נסו שוב.',
  'externalAccess.scopeLost': 'לחיבור הזה אין ההרשאה הנדרשת.',
  'externalAccess.accessLost': 'הגישה אינה זמינה. בדקו את החשבון ואת החברות בארגון.',
  'externalAccess.resync': 'ההשוואה השמורה אינה תקפה עוד. בדקו ואפסו כאן את המעקב.',
  'externalAccess.limit': 'הגעתם למגבלת החיבורים או האחסון. הסירו חיבורים מיותרים או צמצמו את המעקב.',
  'externalAccess.conflict': 'החיבור השתנה במקום אחר. טענו את המצב השמור לפני ניסיון נוסף.',
  'externalAccess.throttled': 'יותר מדי בקשות. המתינו לפני ניסיון נוסף.',
  'externalAccess.missing': 'החיבור הזה אינו זמין עוד.',
  'externalAccess.invalid': 'בדקו את השם, התוקף והגדרות המעקב.',
  'externalAccess.expiryDays': 'תוקף הגישה בימים (1–365)',
  'externalAccess.noExpiry': 'ללא תפוגה',
  'externalAccess.watch': 'מעקב אחר עדכוני העזרה',
  'externalAccess.watchEnabled': 'הפעלת מעקב עבור החיבור הזה',
  'externalAccess.watchExplain': 'הסוכן מבקש תמונות מצב ומאשר אותן לאחר שמירת הדוח. הגדרה זו אינה מפעילה לוח זמנים.',
  'externalAccess.watchLanguage': 'שפת העזרה המועדפת',
  'externalAccess.watchContexts': 'מדורים למעקב',
  'externalAccess.allContexts': 'כל העזרה הזמינה לקריאה',
  'externalAccess.contextsUnavailable': 'לא ניתן לטעון את המדורים הזמינים. בחירת המדורים השמורה נשמרת.',
  'externalAccess.keptContexts': 'חלק מהמדורים השמורים אינם זמינים כעת. הם יישארו בבחירה עד לבחירת כל העזרה או לשינוי הבחירה.',
  'externalAccess.copy': 'העתקה',
  'externalAccess.copied': 'הועתק',
  'externalAccess.copyFailed': 'ההעתקה נכשלה. בחרו והעתיקו את הערך ידנית.',
  'externalAccess.unsaved': 'הגדרות שילוב חיצוני שלא נשמרו',
  'externalAccess.create': 'יצירת מפתח API',
  'externalAccess.name': 'שם',
  'externalAccess.read': 'קריאת עזרה',
  'externalAccess.readDetail': 'קריאה וחיפוש בעזרה המורשית, באיורים, בהקשר המדור ובקישורים ליישום. ללא גישה לרשומות רפואיות או עריכת תוכן.',
  'externalAccess.sync': 'מעקב אחר עדכוני העזרה',
  'externalAccess.syncDetail': 'שמירת השוואה טכנית ואישור עדכוני עזרה שטופלו. הפעולה אינה משנה את תוכן העזרה.',
  'externalAccess.working': 'שומר…',
  'externalAccess.consentTitle': 'חיבור סוכן',
  'externalAccess.consentDetail': 'בדקו את היישום, הארגון וההרשאות לפני מתן גישה.',
  'externalAccess.client': 'היישום המבקש',
  'externalAccess.unverified': 'השם נמסר על ידי היישום עצמו. בדקו את כתובת החזרה ואת הארגון לפני אישור.',
  'externalAccess.loopback': 'כתובת החזרה מובילה ליישום מקומי. המשיכו רק אם התחלתם את הבקשה בלקוח מהימן במחשב.',
  'externalAccess.approve': 'אישור גישה',
  'externalAccess.deny': 'דחייה',
  'externalAccess.clinic': 'ארגון',
  'externalAccess.callback': 'כתובת חזרה',
  'externalAccess.resource': 'המשאב המבוקש',
  'externalAccess.permissions': 'הרשאות',
  'externalAccess.back': 'חזרה לאינטגרציות',
  'externalAccess.state.active': 'פעיל',
  'externalAccess.state.expired': 'פג תוקף',
  'externalAccess.state.revoked': 'בוטל',
  'externalAccess.state.unavailable': 'הגישה אינה זמינה',
  'externalAccess.checkpoint.disabled': 'המעקב כבוי',
  'externalAccess.checkpoint.uninitialized': 'ממתין לתמונת המצב הראשונה',
  'externalAccess.checkpoint.ready': 'ההשוואה נשמרה',
  'externalAccess.checkpoint.pending': 'ממתין לאישור הסוכן',
  'externalAccess.checkpoint.expired': 'תוקף ההשוואה פג; נדרש איפוס',
  'externalAccess.unknown': 'מצב לא מוכר',
  'externalAccess.connection': 'חיבור',
  'externalAccess.selectClinic': 'כדי לשנות הגדרות, בחרו ביישום את הארגון של החיבור. ביטול הגישה נשאר זמין.',
  'externalAccess.rotate': 'החלפת מפתח',
  'externalAccess.revoke': 'ביטול גישה',
  'externalAccess.reload': 'טעינת המצב השמור',
  'externalAccess.reloadFailed': 'לא ניתן לטעון את המצב השמור. הטיוטה שלכם נשמרת.',
  'externalAccess.reloaded': 'הטופס מציג כעת את המצב השמור.',
  'externalAccess.state': 'מצב',
  'externalAccess.created': 'נוצר',
  'externalAccess.expires': 'בתוקף עד',
  'externalAccess.keyPrefix': 'תחילת המפתח',
  'externalAccess.lastUsed': 'שימוש אחרון',
  'externalAccess.lastAck': 'תמונת המצב האחרונה שאושרה',
  'externalAccess.baselineExpires': 'ההשוואה בתוקף עד',
  'externalAccess.reset': 'איפוס ההשוואה השמורה והעדכונים הממתינים',
  'externalAccess.resetExplain': 'איפוס מוחק את ההשוואה השמורה ואת האצווה שלא אושרה. הבקשה הבאה תאתחל נקודת בסיס חדשה. האיפוס אינו מאשר דוח שלא הושלם.',
  'externalAccess.resetRequired': 'שינוי הגדרות אלה דורש איפוס מפורש של ההשוואה השמורה.',
  'externalAccess.save': 'שמירת מעקב',
  'externalAccess.revokeTitle': 'לבטל את החיבור הזה?',
  'externalAccess.rotateTitle': 'להחליף את מפתח ה־API הזה?',
  'externalAccess.revokeDetail': 'הסוכן יאבד גישה מיד. לא ניתן להפעיל מחדש את החיבור הזה.',
  'externalAccess.rotateDetail': 'המפתח הישן יפסיק לפעול מיד. המעקב יישמר. העתיקו את המפתח החדש כאשר יוצג.',
  'externalAccess.kind.oauth': 'יישום מחובר',
  'externalAccess.kind.key': 'מפתח API',
  'externalAccess.manageNamed': 'ניהול {name}',
  'externalAccess.openNamed': 'פתיחת {name}',
  'externalAccess.secretTitle': 'מפתח ה־API החדש שלכם',
  'externalAccess.secretDetail': 'זו ההצגה היחידה של המפתח המלא. העתיקו אותו להגדרות הסודיות של הלקוח. אל תכניסו אותו לכתובות או להודעות בצ׳אט.',
  'externalAccess.secretHide': 'המפתח נשמר — סגירה',
  'externalAccess.mcpUrl': 'כתובת MCP',
  'externalAccess.apiUrl': 'כתובת REST API',
  'externalAccess.empty': 'עדיין אין חיבורים',
  'externalAccess.emptyDetail': 'חברו לקוח תואם באמצעות OAuth או צרו מפתח בארגון שנבחר.',
  'externalAccess.addresses': 'כתובות לחיבור',
  'externalAccess.copyNamed': 'העתקת {label}',
  'externalAccess.facts': 'פרטי החיבור',
  'externalAccess.access': 'גישה',
  'externalAccess.secretDismiss': 'שמרתי את המפתח — הסתרה',
  'externalAccess.readChip': 'קריאה',
  'externalAccess.syncChip': 'עדכונים',
  "designAccess.title": "גישה למקור ולהצעות עיצוב",
  "designAccess.subtitle": "חברו עוזר לקריאת קוד המקור ולשמירת הצעות עיצוב. שינויים ביישום דורשים אישור ויישום נפרדים.",
  "designAccess.read": "קריאת קוד המקור",
  "designAccess.readDetail": "קריאת מאגר הפרויקט, רכיבים, סגנונות והצעות שנשמרו. הרשאה זו אינה מעניקה גישה לנתונים קליניים.",
  "designAccess.write": "שמירת הצעות עיצוב",
  "designAccess.writeDetail": "שמירת קבצים עם הסבר והיסטוריית גרסאות. פעולה זו אינה משנה את היישום הפעיל.",
  "designAccess.consentDetail": "העניקו ללקוח זה גישה לקוד המקור ולהצעות עיצוב מטעם החשבון שלכם. בדקו את ההרשאות ואת כתובת החזרה.",
  "designAccess.ineligible": "לחשבון שלכם אין הרשאה לגשת לקוד המקור ולהצעות עיצוב. פנו למנהל המערכת.",
  "designAccess.open": "ניהול חיבורים למקור ולעיצוב",
  "designAccess.emptyDetail": "הוסיפו את כתובת MCP כחיבור OAuth בעוזר שלכם, ואז בדקו ואשרו כאן את הבקשה.",
  "designAccess.cancel": "שמירת הגישה",
  "designProposals.subtitle": "טיוטות שעוזר שמר דרך חיבור העיצוב. הצפייה בטיוטה אינה משנה את היישום.",
  "designProposals.open": "פתיחת טיוטות העיצוב",
  "designProposals.empty": "אין עדיין טיוטות",
  "designProposals.emptyDetail": "טיוטות שעוזר שומר דרך חיבור העיצוב יופיעו כאן.",
  "designProposals.connect": "איך לחבר עוזר",
  "designProposals.failed": "לא ניתן היה לטעון את טיוטות העיצוב. נסו שוב.",
  "designProposals.forbidden": "טיוטות העיצוב זמינות רק לחשבונות עם גישה למקור ולעיצוב.",
  "designProposals.notFound": "הטיוטה או הגרסה הזו אינן זמינות עוד.",
  "designProposals.layoutManifest": "מסודר",
  "designProposals.layoutInferred": "ללא רשימת עמודים",
  "designProposals.layoutInvalid": "דורש תיקון",
  "designProposals.layoutInferredDetail": "לטיוטה אין רשימת עמודים, ולכן העמודים מוצגים לפי סדר הקבצים.",
  "designProposals.layoutInvalidDetail": "לא ניתן להשתמש ברשימת העמודים של טיוטה זו, ולכן העמודים מוצגים לפי סדר הקבצים. בקשו מהעוזר לתקן אותה.",
  "designProposals.columnTitle": "טיוטה",
  "designProposals.columnArea": "תחום",
  "designProposals.columnLayout": "מבנה",
  "designProposals.columnPages": "עמודים",
  "designProposals.columnVersions": "גרסאות",
  "designProposals.columnUpdated": "עודכן",
  "designProposals.columnAuthor": "נשמר על ידי",
  "designProposals.page": "עמוד",
  "designProposals.width": "רוחב התצוגה",
  "designProposals.widthFull": "מחשב",
  "designProposals.widthTablet": "טאבלט",
  "designProposals.widthPhone": "טלפון",
  "designProposals.fullScreen": "מסך מלא",
  "designProposals.frameTitle": "עמוד הטיוטה: {title}",
  "designProposals.version": "גרסה",
  "designProposals.versions": "גרסאות",
  "designProposals.versionOption": "{date} · {author}",
  "designProposals.latest": "אחרונה",
  "designProposals.savedBy": "נשמר",
  "designProposals.unknownAuthor": "חשבון לא ידוע",
  "designProposals.noPages": "אין בטיוטה זו עמודים להצגה.",
  "designProposals.explanation": "הסבר",
  "designProposals.noExplanation": "אין לטיוטה זו הסבר.",
  "designProposals.olderVersion": "אתם צופים בגרסה קודמת.",
  "designProposals.showLatest": "הצגת האחרונה",
} as const
